import React from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 10%;
  background-color: #111;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 20px;
  @media only screen and (max-width: 480px) {
    height: 20%;
    padding-top: 30px;
  }
`;

const Wrapper = styled.span`
  font-size: 20px;
  @media only screen and (max-width: 480px) {
    font-size: 12px;
  }
`;

const Link = styled.a`
  text-decoration: none;
  color: crimson;
`;

const Footer = () => {
  return (
    <Container>
      <Wrapper>
        Created with love by
        <Link href="mahmoudayed@hotmail.fr"> &#9825; Mahmoud &#9825; </Link>|
        Ⓒ2022 All rights reserved.
      </Wrapper>
    </Container>
  );
};

export default Footer;
